import { render, staticRenderFns } from "./footer-btn.vue?vue&type=template&id=fba0fc08&scoped=true"
import script from "./footer-btn.vue?vue&type=script&lang=js"
export * from "./footer-btn.vue?vue&type=script&lang=js"
import style0 from "./footer-btn.vue?vue&type=style&index=0&id=fba0fc08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba0fc08",
  null
  
)

export default component.exports